export default {
    visible: false,
    dropDownOpen: false,
    permissions: [],
    topbar_left_buttons: [],
    topbar_right_buttons: [],
    topbarextended_left_buttons: [],
    topbarextended_right_buttons: [],
    qid: 0,
    gid: 0,
    sid: 0,
    type: '',
    showSaveButton: false,
    showCloseButton: false,
    closeButtonUrl: ''
};
